import URLS from "@api/constants/urls";
import {
  handleGlobalDeleteRequest,
  handleGlobalPostRequest,
  handleGlobalPatchRequest,
} from "@api/functions/changeRequests";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { URLSearchParamsInit } from "react-router-dom";
import {
  ISubsegmentResponseSchema,
  ISubsegmentSubmitSchema,
} from "./subsegmentAPI.types";
import { IGlobalMetaSchema } from "@api/types/globalService.types";

const getAllSubsegmentAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{ data: ISubsegmentResponseSchema[]; meta: IGlobalMetaSchema }> =>
  handleGlobalGetRequestQuery({ url: URLS.SUBSEGMENTS, searchParams, signal });

const getSingleSubsegmentAPI = (
  id: string
): Promise<{ data: ISubsegmentResponseSchema }> =>
  handleGlobalGetRequestQuery({
    url: `${URLS.SUBSEGMENTS}/${id}`,
  });

const createSubsegmentAPI = (
  data: ISubsegmentSubmitSchema
): Promise<{ data: ISubsegmentResponseSchema }> =>
  handleGlobalPostRequest({ url: URLS.SUBSEGMENTS, data });

const updateSubsegmentAPI = (
  data: ISubsegmentSubmitSchema
): Promise<{ data: ISubsegmentResponseSchema }> =>
  handleGlobalPatchRequest({ url: `${URLS.SUBSEGMENTS}/${data.id}`, data });

const deleteSubsegmentAPI = (id: number) =>
  handleGlobalDeleteRequest({ url: `${URLS.SUBSEGMENTS}/${id}` });

export {
  getAllSubsegmentAPI,
  getSingleSubsegmentAPI,
  createSubsegmentAPI,
  updateSubsegmentAPI,
  deleteSubsegmentAPI,
};
